"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parse = function (data, keyBuilder) {
    if (keyBuilder === void 0) { keyBuilder = null; }
    return data.reduce(function (acc, current) {
        var len = Object.keys(current).length;
        var syblings = acc;
        var parent = null;
        for (var level = 1; level <= len; level += 1) {
            var code = keyBuilder ? keyBuilder.code(level) : "aP_L" + level + "Code";
            var nameKey = keyBuilder
                ? keyBuilder.nameKey(level)
                : "aP_L" + level + "Category";
            var name_1 = current[nameKey];
            var id = current[code] || name_1;
            if (id && name_1) {
                if (!syblings[id]) {
                    syblings[id] = {
                        id: id,
                        name: name_1,
                        code: code,
                        level: level,
                        children: {},
                        originalData: current,
                        parent: parent,
                        syblings: syblings,
                    };
                }
                parent = syblings[id];
                syblings = syblings[id].children;
            }
        }
        return acc;
    }, {});
};
exports.createMap = function (data, keyBuilder) {
    if (keyBuilder === void 0) { keyBuilder = null; }
    var map = {};
    data.forEach(function (item) {
        var len = Object.keys(item).length;
        for (var i = 1; i <= len; i += 1) {
            var code = keyBuilder ? keyBuilder.code(i) : "aP_L" + i + "Code";
            var nameKey = keyBuilder ? keyBuilder.nameKey(i) : "aP_L" + i + "Category";
            var name_2 = item[nameKey];
            var id = item[code];
            if (id && !map[id]) {
                map[id] = name_2;
            }
        }
    });
    return map;
};
exports.getCodeFromItem = function (item, keyBuilder) {
    if (keyBuilder === void 0) { keyBuilder = null; }
    var len = Object.keys(item).length;
    for (var i = len; i > 0; i -= 1) {
        var code = keyBuilder ? keyBuilder.code(i) : "aP_L" + i + "Code";
        var id = item[code];
        var nameKey = keyBuilder ? keyBuilder.nameKey(i) : "aP_L" + i + "Category";
        var name_3 = item[nameKey];
        if (id) {
            return { id: id, name: name_3 };
        }
    }
    return {};
};
exports.getItemByCode = function (data, searchCode, keyBuilder) {
    if (keyBuilder === void 0) { keyBuilder = null; }
    var result = null;
    data.find(function (item) {
        var len = Object.keys(item).length;
        var acc = {};
        for (var i = 1; i <= len; i += 1) {
            var code = keyBuilder ? keyBuilder.code(i) : "aP_L" + i + "Code";
            var id = item[code];
            acc[code] = id;
            if (id === searchCode) {
                result = acc;
                return true;
            }
        }
        return false;
    });
    return result;
};
exports.industryKeyBuilder = {
    code: function (i) { return "ap_indus_v0.1_L" + i + "_Code"; },
    nameKey: function (i) { return "ap_indus_v0.1_L" + i; },
};
//# sourceMappingURL=utils.js.map